import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import easydropdown from "easydropdown-a11y";
import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { generateQueryString } from "@/scripts/common/util";
import "@/styles/components/dropdown.css";
import "@/styles/components/slider.css";
import "./resources.css";

const form = document.querySelector(".filter-form");

const setupDropdown = (el) => {
  if (el.tagName !== "SELECT") {
    return;
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  };

  easydropdown(el, opts);
};

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = () => {
  form.reset();
  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));
  form.querySelectorAll("select").forEach((x) => (x.value = ""));

  window.history.replaceState({}, "", form.action);

  updateResults();
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  setupSliders();

  if (res.isFiltered) {
    form.classList.add("is-filtered");
    scrollToIfNeeded(pageContent, 24);
  } else {
    form.classList.remove("is-filtered");
  }
};

const setupSlider = (el) => {
  const container = el.querySelector(".swiper");

  const swiper = new Swiper(container, {
    modules: [A11y, Navigation],
    speed: 500,
    slidesPerView: 1,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    simulateTouch: false,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
      },
    },
    on: {
      init: (swiper) => {
        if (swiper.isLocked) {
          el.classList.add("is-locked");
        } else {
          el.classList.remove("is-locked");
        }
      },
      resize: (swiper) => {
        if (swiper.isLocked) {
          el.classList.add("is-locked");
        } else {
          el.classList.remove("is-locked");
        }
      },
    },
  });

  return swiper;
};

const setupSliders = () => {
  document.querySelectorAll(".resource-type").forEach((el) => {
    let swiper = setupSlider(el);

    el.addEventListener("resource:toggle", (e) => {
      const isViewAll = e.detail.all;

      if (isViewAll) {
        el.classList.add("is-view-all");
        el.classList.add("is-transitioning");
        swiper.destroy(true, true);
      } else {
        el.classList.remove("is-view-all");
        swiper = setupSlider(el);

        requestAnimationFrame(() => {
          el.classList.remove("is-transitioning");
        });
      }
    });

    if (el.classList.contains("as-expanded") && window.matchMedia("(min-width: 768px)").matches) {
      el.classList.add("is-view-all");
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    form.querySelectorAll("select:not([multiple])").forEach((el) => setupDropdown(el));

    delegate(".filter-form select", "change", handleFilterChange);
    delegate(".filter-form", "submit", handleFilterChange);
    delegate(".filter-form-clear", "click", handleFilterClear);
  }

  setupSliders();
});
